import { useEffect, useState } from 'react'

export default function UsePageVisible() {
  const [isVisible, setVisible] = useState<boolean>(document.visibilityState === 'visible')
  function listener(e: Event) {
    setVisible(document.visibilityState === 'visible')
  }
  useEffect(() => {
    window.addEventListener('visibilitychange', listener)
    return () => {
      window.removeEventListener('visibilitychange', listener)
    }
  }, [])
  return { isVisible }
}
